function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.33333 8.00004H7.99999V7.33337H6.66666V9.33337H17.3333V7.33337H16V8.00004H14.6667V7.33337H9.33333V8.00004ZM17.3333 10.6667H6.66666V17.3334H17.3333V10.6667ZM14.6667 6.00004H9.33333V5.33337H7.99999V6.00004H6.66666C5.93028 6.00004 5.33333 6.59699 5.33333 7.33337V17.3334C5.33333 18.0698 5.93028 18.6667 6.66666 18.6667H17.3333C18.0697 18.6667 18.6667 18.0698 18.6667 17.3334V7.33337C18.6667 6.59699 18.0697 6.00004 17.3333 6.00004H16V5.33337H14.6667V6.00004ZM9.99999 13.3334H8.66666V12H9.99999V13.3334ZM11.3333 13.3334H12.6667V12H11.3333V13.3334ZM14 13.3334V12H15.3333V13.3334H14ZM8.66666 16H9.99999V14.6667H8.66666V16ZM12.6667 16H11.3333V14.6667H12.6667V16Z",
  fill: "#006AFF"
});

function SvgScheduleAssignmentPickupDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgScheduleAssignmentPickupDetails);
export default __webpack_public_path__ + "static/media/schedule-assignment-pickup-details.3cd8c956.svg";
export { ForwardRef as ReactComponent };